export default {
  hero: {
    title: "بیایید در ارتباط باشیم",
    subtitle: "آماده‌اید ایده‌هایتان را واقعیت کنید؟",
    body: "خیلی دوست داریم درباره پروژه‌تان بشنویم و ببینیم چطور می‌توانیم به رسیدن به اهدافتان کمک کنیم. برای ما پیام بگذارید تا با هم چیزی شگفت‌انگیز بسازیم!",
  },
  dialog: {
    successTitle: "موفق شد!",
    errorTitle: "خطا",
    successFallback: "پیام با موفقیت ارسال شد!",
    errorFallback: "ارسال پیام ناموفق بود. لطفاً دوباره تلاش کنید.",
    networkError: "خطای شبکه: {{error}}. لطفاً اتصال خود را بررسی کرده و دوباره تلاش کنید.",
    ok: "تأیید",
  },
  form: {
    title: "برای ما پیام بفرستید",
    nameLabel: "نام شما",
    namePlaceholder: "نام خود را وارد کنید",
    emailLabel: "آدرس ایمیل",
    emailPlaceholder: "ایمیل خود را وارد کنید",
    subjectLabel: "موضوع",
    subjectPlaceholder: "موضوع پیام شما چیست؟",
    messageLabel: "پیام",
    messagePlaceholder: "درباره پروژه‌تان بگویید یا هر سوالی دارید بپرسید...",
    sending: "در حال ارسال...",
    send: "ارسال پیام",
  },
  info: {
    title: "با ما در ارتباط باشید",
    body: "سوالی دارید یا می‌خواهید با هم کار کنیم؟ خیلی دوست داریم از شما بشنویم. راه ارتباطی دلخواهتان را انتخاب کنید.",
    cards: {
      email: { title: "برای ما ایمیل بزنید", desc: "هر زمان که خواستید ایمیل بفرستید!" },
      phone: { title: "با ما تماس بگیرید", desc: "شنبه تا پنجشنبه، ۹ صبح تا ۶ عصر" },
      location: { title: "به ما سر بزنید", desc: "به دفتر ما بیایید و سلام کنید" },
    },
    followTitle: "ما را دنبال کنید",
  },
  faq: {
    title: "سوالات پرتکرار",
    subtitle: "پاسخ سریع به سوالات رایج درباره خدمات و روند کار ما.",
    items: {
      services: {
        question: "چه خدماتی ارائه می‌دهید؟",
        answer:
          "ما در توسعه وب، اپلیکیشن‌های موبایل، راه‌حل‌های اینترنت اشیا، دواپس و مشاوره تحول دیجیتال تخصص داریم. از ایده تا استقرار، کل چرخه توسعه را پوشش می‌دهیم.",
      },
      timeline: {
        question: "یک پروژه معمولی چقدر زمان می‌برد؟",
        answer:
          "زمان‌بندی پروژه بسته به پیچیدگی و دامنه آن متفاوت است. وب‌سایت‌های ساده ۲ تا ۴ هفته و اپلیکیشن‌های پیچیده ۲ تا ۶ ماه زمان می‌برند. در مشاوره اولیه، زمان‌بندی دقیق ارائه می‌کنیم.",
      },
      startups: {
        question: "آیا با استارتاپ‌ها همکاری می‌کنید؟",
        answer:
          "قطعاً! ما عاشق کار با استارتاپ‌ها هستیم و چالش‌های خاص شما را درک می‌کنیم. قیمت‌گذاری منعطف داریم و می‌توانیم خدماتمان را با رشد کسب‌وکار شما مقیاس‌پذیر کنیم.",
      },
      process: {
        question: "روند توسعه شما چگونه است؟",
        answer:
          "ما از متدولوژی‌های اجایل با جلسات منظم، توسعه تکرارشونده و بازخورد پیوسته پیروی می‌کنیم. شما در تمام مراحل با شفافیت کامل همراه خواهید بود.",
      },
      support: {
        question: "آیا پشتیبانی مستمر ارائه می‌دهید؟",
        answer:
          "بله! ما بسته‌های نگهداری و پشتیبانی کامل ارائه می‌دهیم تا اپلیکیشن‌های شما روان و به‌روز با آخرین فناوری‌ها باقی بمانند.",
      },
      communication: {
        question: "ارتباط پروژه را چگونه مدیریت می‌کنید؟",
        answer:
          "ما ارتباط باز از طریق جلسات منظم، گزارش پیشرفت و ابزارهای مشترک حفظ می‌کنیم. همیشه از وضعیت پروژه‌تان آگاه خواهید بود.",
      },
    },
  },
};
